import { GoalStatusType } from './lti.enum';

export abstract class LtiGoalStatusTypeRouteResolver {

  static getStateNameToContinueGoal(status: GoalStatusType): string {
    if (status === GoalStatusType.NO_MODEL) {
      return 'page.lti.investor-profile.select';
    } else if (status === GoalStatusType.NO_PORTFOLIO || status === GoalStatusType.PORTFOLIO_NO_ACCOUNT) {
      return 'page.lti.fund-goal';
    }
    return 'page.lti.dashboard-details';
  }

}
